var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _path, _circle17, _circle18, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearningBasedDisability(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 57 58"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.543,
    cy: 8.241,
    r: 1.466,
    fill: "#50B3EC",
    transform: "rotate(-3 49.543 8.241)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.252,
    cy: 1.815,
    r: 1.466,
    fill: "#50B3EC",
    transform: "rotate(-3 21.252 1.815)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.252,
    cy: 1.815,
    r: 1.466,
    fill: "#50B3EC",
    transform: "rotate(-3 21.252 1.815)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.54,
    cy: 23.103,
    r: 1.466,
    fill: "#50B3EC",
    transform: "rotate(-3 1.54 23.103)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.121,
    cy: 47.664,
    r: 1.466,
    fill: "#50B3EC",
    transform: "rotate(-3 10.121 47.664)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.682,
    cy: 55.667,
    r: 1.466,
    fill: "#50B3EC",
    transform: "rotate(-3 35.682 55.667)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.682,
    cy: 55.667,
    r: 1.466,
    fill: "#50B3EC",
    transform: "rotate(-3 35.682 55.667)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.392,
    cy: 37.534,
    r: 1.466,
    fill: "#50B3EC",
    transform: "rotate(-3 55.392 37.534)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.833,
    cy: 46.457,
    r: 1.466,
    fill: "#50B3EC",
    transform: "rotate(-3 45.833 46.457)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.764,
    cy: 4.511,
    r: 1.466,
    fill: "#50B3EC",
    transform: "rotate(-3 35.764 4.511)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.936,
    cy: 21.812,
    r: 1.466,
    fill: "#50B3EC",
    transform: "rotate(-3 53.936 21.812)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.153,
    cy: 11.775,
    r: 1.466,
    fill: "#50B3EC",
    transform: "rotate(-3 11.153 11.775)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.528,
    cy: 52.351,
    r: 1.466,
    fill: "#50B3EC",
    transform: "rotate(-3 22.528 52.351)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.017,
    cy: 35.05,
    r: 1.466,
    fill: "#50B3EC",
    transform: "rotate(-3 6.017 35.05)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.465,
    cy: 23,
    r: 2.667,
    fill: "#3420ED"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.798,
    cy: 31.333,
    r: 2.667,
    fill: "#3420ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3420ED",
    fillRule: "evenodd",
    d: "M34.799 16a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-2.69a2.667 2.667 0 110-4.62V18a2 2 0 00-2-2z",
    clipRule: "evenodd"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.132,
    cy: 34,
    r: 2.667,
    fill: "#3420ED",
    transform: "rotate(-180 30.132 34)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.799,
    cy: 25.667,
    r: 2.667,
    fill: "#3420ED",
    transform: "rotate(-180 21.8 25.667)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3420ED",
    fillRule: "evenodd",
    d: "M26.799 41a2 2 0 002-2V29a2 2 0 00-2-2h-10a2 2 0 00-2 2v2.69a2.667 2.667 0 110 4.62V39a2 2 0 002 2z",
    clipRule: "evenodd"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgLearningBasedDisability as ReactComponent };